// extracted by mini-css-extract-plugin
export default {"messagePair":"PromptMessagePair-module__messagePair__MCFB99R","pairHeader":"PromptMessagePair-module__pairHeader__gowhMvt"};